import { Pedido, FundTecItem, OpmeBundle, ProcedimentoBundle } from "../types/resources.types";
import { Surgery } from "../types/patient.types";
import { formatDate } from "../i18n";
import {
  ApiOpmeKit, ApiOpmeRow, ApiProcedureKit, ApiProcedureRow, Kit, OpmeItem, ProcedureItem,
} from "../types/order.types";

// Pedido salvo → cabeçalho do recurso (features/appeals).
export function surgeryToPedido(s: Surgery): Pedido {
  const id = s.timestamp || "Sem id";
  const codigo = s.procedimentos_validados?.split(" ")[0] || "Sem codigo";

  const data_desejada = formatDate(id);

  const procedimento =
    s.procedimentos_validados?.split(" ")[1] || "Sem procedimento";
  const paciente = s.pacient_name ?? "Sem paciente";

  return {
    id: String(id),
    codigo: String(codigo),
    paciente: String(paciente),
    procedimento: String(procedimento),
    data: String(data_desejada),
    status: "PENDENTE",
  };
}

export function procedimentosToFundTecItems(
  procedimentos: ProcedimentoBundle[]
): FundTecItem[] {
  return (procedimentos ?? []).map((p) => ({
    id: p.procedimento_id,
    nome: p.nome,
    categoria: p.categoria,
    justificativa: p.justificativa_relacao_com_caso,
    referencias: p.referencias ?? [],
    alvo_tipo: "procedimento",
  }));
}

export function opmesToFundTecItems(opmes: OpmeBundle[]): FundTecItem[] {
  return (opmes ?? []).map((o) => ({
    id: o.opme_id,
    nome: o.nome,
    categoria: o.categoria,
    justificativa: o.justificativa_relacao_com_caso,
    referencias: o.referencias ?? [],
    alvo_tipo: "opme",
  }));
}
// ── Pedido: backend ↔ front (src/types/order.types.ts) ──────────────────────

/** "x2" | "2" | "" → 2 (mínimo 1). */
const parseQuantity = (raw: string | number) => Math.max(1, parseInt(String(raw).replace(/\D/g, ""), 10) || 1);

export const procedureFromApi = (row: ApiProcedureRow): ProcedureItem => ({
  code: row.code,
  description: row.description,
  quantity: parseQuantity(row.quantity),
});

export const procedureToApi = (item: ProcedureItem): ApiProcedureRow => ({
  code: item.code,
  description: item.description,
  quantity: `x${item.quantity}`,
});

export const opmeFromApi = ([name, quantity]: ApiOpmeRow): OpmeItem => ({ name, quantity: parseQuantity(quantity) });

export const opmeToApi = (item: OpmeItem): ApiOpmeRow => [item.name, String(item.quantity)];

export const procedureKitFromApi = (kit: ApiProcedureKit): Kit<ProcedureItem> => ({
  id: kit.id,
  name: kit.nome,
  items: kit.procedimentos.map((p) => ({ code: p.cod_procedimento, description: p.nome, quantity: p.quantidade })),
  recommended: kit.escolhido,
});

export const opmeKitFromApi = (kit: ApiOpmeKit): Kit<OpmeItem> => ({
  id: kit.id,
  name: kit.nome,
  items: kit.opmes.map((o) => ({ name: o.nome, quantity: o.quantidade })),
  recommended: kit.escolhido,
});
